export default {
  wishlist: {
    sidebar: {
      headerTitle: 'Deine Erlebnisse',
      items: 'Artikel',
    },
    productCard: {
      removeFromWishlistLabel: 'Entfernen',
      addToWishlistLabel: 'Merken',
    },
  },
}
